var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#DBF5FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6C8.91049 6 6 8.91049 6 12.5C6 16.0895 8.91049 19 12.5 19C16.0895 19 19 16.0895 19 12.5C19 8.91049 16.0895 6 12.5 6ZM12.5 17.8973C9.51987 17.8973 7.10268 15.4801 7.10268 12.5C7.10268 9.51987 9.51987 7.10268 12.5 7.10268C15.4801 7.10268 17.8973 9.51987 17.8973 12.5C17.8973 15.4801 15.4801 17.8973 12.5 17.8973Z",
    fill: "#0FBCF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0346 14.3368L12.9657 12.8409V9.24998C12.9657 9.18614 12.9134 9.13391 12.8496 9.13391H12.1517C12.0879 9.13391 12.0356 9.18614 12.0356 9.24998V13.2457C12.0356 13.2835 12.0531 13.3183 12.0835 13.3401L14.4833 15.0898C14.5355 15.1275 14.6081 15.1159 14.6458 15.0652L15.0608 14.4993C15.0985 14.4456 15.0869 14.3731 15.0346 14.3368Z",
    fill: "#0FBCF9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeCircle);
export default __webpack_public_path__ + "static/media/time-circle.0411f3837398a4337ee0df83a67938af.svg";
export { ForwardRef as ReactComponent };